<template>
    <ml-layout>
        <!-- <div class="menu">
            <div class="ml-main">
                <el-row>
                    <el-col :span="2" class="title">专业大类：</el-col>
                    <el-col :span="22" class="main">
                        <a
                            v-for="(item, index) in nLabList"
                            :key="index"
                            href="javascript:;"
                            :class="index == 0 ? 'on' : ''"
                        >
                            {{ item }}({{
                                nLabCountList[index] ? nLabCountList[index] : 0
                            }})
                        </a>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="2" class="title">关键词：</el-col>
                    <el-col :span="22" class="main">
                        <el-input
                            size="mini"
                            placeholder="项目名称"
                            class="search"
                        ></el-input>
                        <el-input
                            size="mini"
                            placeholder="负责人姓名"
                            class="search"
                        ></el-input>
                        <el-button type="primary" size="mini">
                            搜索
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </div> -->
        <div class="ml-main">
            <!-- <el-row v-for="item in 4" :key="item">
                <el-col :span="8">
                    <ml-card :info="info"></ml-card>
                </el-col>
                <el-col :span="8">
                    <ml-card :info="info"></ml-card>
                </el-col>
                <el-col :span="8">
                    <ml-card :info="info"></ml-card>
                </el-col>
            </el-row> -->
            实验中心
        </div>
    </ml-layout>
</template>

<script>
import MlLayout from "@/components/MlLayout";
// import MlCard from "@/components/MlCard";

export default {
    name: "Home",
    components: {
        // MlCard,
        MlLayout
    },
    data() {
        return {
            info: {
                imageUrl: "http://www.ilab-x.com/imgview/90825_388x224.jpg",
                title: "认罪认罚虚拟仿真实验",
                school: "广东外语外贸大学",
                leader: "杨帆",
                count: 23318
            },
            nLabList: [
                "法学类",
                "建筑类",
                "马克思主义理论学",
                "体育学类",
                "历史学类",
                "物理学类",
                "电气类",
                "矿业类",
                "兵器类",
                "农业工程类",
                "林业工程类",
                "自然保护与环境生态类",
                "公共卫生与预防医学类",
                "法医学类",
                "医学技术类",
                "经济管理类",
                "艺术学类",
                "生物科学类",
                "机械类",
                "电子信息类",
                "航空航天类",
                "化工与制药类",
                "交通运输类",
                "核工程类",
                "临床医学类",
                "药学类",
                "化学类",
                "心理学类",
                "能源动力类",
                "土木类",
                "测绘类",
                "环境科学与工程类",
                "食品科学与工程类",
                "植物类",
                "动物类",
                "基础医学类",
                "中医类",
                "护理学类",
                "教育学类",
                "地质类",
                "文学类",
                "天文学类",
                "地理科学类",
                "大气科学类",
                "海洋科学类",
                "地球物理学类",
                "地质学类",
                "力学类",
                "仪器类",
                "材料类",
                "自动化类",
                "计算机类",
                "水利类",
                "纺织类",
                "轻工类",
                "海洋工程类",
                "生物医学工程类",
                "安全科学与工程类",
                "生物工程类",
                "公安技术类",
                "其它类"
            ],
            nLabCountList: [
                2079,
                15,
                21,
                14,
                27,
                19,
                53,
                64,
                35,
                20,
                22,
                9,
                27,
                26,
                11
            ]
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.menu {
    width: 100%;
    background-color: #f6f7f8;

    .title {
        color: #0063af;
    }

    .main {
        float: left;

        a {
            display: inline-block;
            margin-right: 20px;
            padding: 5px 0;
            color: #000;
        }

        .on {
            color: #fff;
            background: #0063af;
            border-radius: 3px;
            padding: 5px 20px;
        }

        .search {
            width: 200px;
            margin-right: 8px;
        }
    }
}
.ml-card {
    margin: 8px;
}
</style>
